import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { UiWidget } from '@pt/pt-models';
import { FormControl, FormGroup } from '@angular/forms';
import { WidgetRadiobuttonPreviewV0Dto } from './models/widget-radiobutton-preview-v0.dto';
// noinspection ES6PreferShortImport
import { ValidatorGenerator } from '../../../utils';
import { WidgetViewMode } from '../../../widget-internal-status';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'pt-widget-radiobutton-v0-select',
  template: `
    <form [formGroup]='formGroup'
          class="rbfc-v0"
          *ngIf='radioButtons && formGroup'>
      <ng-select
        class="radio-select"
        [items]='radioButtons'
        [multiple]='false'
        [closeOnSelect]="true"
        [hideSelected]="false"
        formControlName='value'
        bindValue="uuid"
        appendTo="body">
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          {{ item.label }}
          <pt-w-help [help]='item?.help'></pt-w-help>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
          {{ item.label }}
          <pt-w-help [help]='item?.help'></pt-w-help>
        </ng-template>
      </ng-select>
    </form>
  `,
  styles: [`

  `]
})
export class WidgetRadiobuttonV0SelectComponent implements OnChanges, OnDestroy {
  @Input() widget: UiWidget;
  @Input() radioButtons: WidgetRadiobuttonPreviewV0Dto[];
  @Input() viewMode: WidgetViewMode;
  @Input() isLoading = false;

  @Output() valueChange = new EventEmitter<string>();
  public formGroup: FormGroup;
  private destroy$ = new Subject();

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.widget && this.radioButtons?.length > 0) {
      this.initFormGroupIfNull();
    }

    if (changes.isLoading || changes.viewMode) {
      this.checkIsDisabled();
    }

  }

  private checkIsDisabled() {
    switch (true) {
      case this.viewMode === 'PREVIEW':
      case this.viewMode === 'ERROR':
      case this.isLoading:
        if (this.formGroup.enabled) {
          this.formGroup.disable({ emitEvent: false });
        }
        break;
      default:
        if (this.formGroup.disabled) {
          this.formGroup.enable({ emitEvent: false });
        }
    }
  }

  private initFormGroupIfNull() {
    this.destroy$.next(true);
    const formGroupValidators = ValidatorGenerator.generateFromGroupValidator(this.widget?.validators);
    const validators = ValidatorGenerator.generateValidator(this.widget?.validators);
    const asyncValidators = ValidatorGenerator.generateAsyncValidator(this.widget?.validators);
    this.formGroup = new FormGroup({
      value: new FormControl(this.widget.value, validators, asyncValidators)
    }, { validators: formGroupValidators });

    if (this.viewMode && this.viewMode === 'PREVIEW' || this.viewMode === 'LOADING' || this.isLoading) {
      this.formGroup.disable();
    } else {
      this.formGroup.enable();
    }

    this.formGroup.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.valueChange.emit(value.value);
    });
  }
}




